import { SpeakerDetailsForm } from "./SpeakerDetailsForm";

export * from "./SpeakerDetailsForm";
export default SpeakerDetailsForm;
